var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExploreMoreCountries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "country",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.496,
    height: 79.364,
    viewBox: "0 0 80.496 79.364",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_53989",
    "data-name": "Path 53989",
    d: "M38.812,45.48A37.7,37.7,0,1,0,91.128,35.215,37.7,37.7,0,0,0,38.812,45.48Z",
    transform: "translate(-27.308 -24.841)",
    fill: "#3d9ae2",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46496",
    "data-name": "Group 46496",
    transform: "translate(5.092 3.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53990",
    "data-name": "Path 53990",
    d: "M416.044,344.433a22.076,22.076,0,0,1-6.077,3.7c-7.564,2.674-11.118,7.724-8.862,15.806A37.886,37.886,0,0,0,416.044,344.433Z",
    transform: "translate(-342.57 -294.813)",
    fill: "#91dc5a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53991",
    "data-name": "Path 53991",
    d: "M104.5,329.582a37.733,37.733,0,0,0,39.515,8.384,9.162,9.162,0,0,0-2.238-2.71c-2.523-2.041-5.738-1.128-7.458-4.513-3.49-6.848-4.564-2.771-8.889-6.3a4.5,4.5,0,0,1-.789-5.711c3.857-5.247-3.582-15.31-11.315-5.844-2.458,3.013-6.49,10.091-8.825,16.7Z",
    transform: "translate(-93.162 -264.935)",
    fill: "#91dc5a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53992",
    "data-name": "Path 53992",
    d: "M151.551,46.491c1.431-.729,8.407-5.825,8.761-5.729,1.578-1.5,2.064,3.472,1.426,4.894C159,51.77,167.251,53.8,165.081,59.1c-1.449,3.55-9.949,3.3-2.564,7.128,4.541,2.353,8.907-1.844,14.242.371,3.747,1.555,17.783,5.266,16.251-1.486-.688-3.032-9.073-6.513-10.866-11.976-3.88-11.825-8.081-7.059-13.045-17.035-1.06-2.119-.849-4.679-1.06-6.738a37.843,37.843,0,0,0-27.071,5.591C143.285,40.707,145.827,49.421,151.551,46.491Z",
    transform: "translate(-123.898 -28.821)",
    fill: "#91dc5a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53993",
    "data-name": "Path 53993",
    d: "M46.632,143.681c4.28,7.064-1.812,7.357-4.321,13.82-1.22,3.137-2.968,7.958-5.146,10.485a37.7,37.7,0,0,1,1.633-39.4c.271-.4.546-.789.826-1.174,5.389,4.307,4.275,11.76,7.009,16.274Z",
    transform: "translate(-32.386 -111.907)",
    fill: "#91dc5a",
    fillRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53994",
    "data-name": "Path 53994",
    d: "M116.637,405.629a37.628,37.628,0,0,1-9.26-8.83,65.32,65.32,0,0,0-2.877,6.793,37.733,37.733,0,0,0,39.515,8.385c-.079-.151-.161-.294-.248-.436A37.588,37.588,0,0,1,116.637,405.629Z",
    transform: "translate(-88.071 -334.981)",
    fill: "#83c651",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53995",
    "data-name": "Path 53995",
    d: "M141.914,42.841a37.4,37.4,0,0,1,11-7.536,37.666,37.666,0,0,0-11.944,5.119C141.276,41.19,141.588,42.006,141.914,42.841Z",
    transform: "translate(-118.806 -30.321)",
    fill: "#83c651",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53996",
    "data-name": "Path 53996",
    d: "M42.747,131.356a11.122,11.122,0,0,0-3.1-3.949c-.28.385-.555.775-.826,1.174a37.933,37.933,0,0,0-3.894,7.472,37.39,37.39,0,0,0-2.321,9.719,37.878,37.878,0,0,0,4.582,22.214c1.665-1.936,3.082-5.215,4.2-8.05a37.81,37.81,0,0,1-.344-24.282,37.162,37.162,0,0,1,1.7-4.3Z",
    transform: "translate(-27.322 -107.942)",
    fill: "#83c651",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53997",
    "data-name": "Path 53997",
    d: "M82.165,72.8a37.894,37.894,0,0,0-3.463,4l-.312.422h0a11.122,11.122,0,0,1,3.1,3.949c.041-.092.087-.183.128-.275a38.359,38.359,0,0,1,2.747-4.8c.206-.312.422-.619.638-.922a37.409,37.409,0,0,1,4.169-4.894c-.326-.835-.638-1.651-.945-2.417A37.526,37.526,0,0,0,82.165,72.8Z",
    transform: "translate(-66.066 -57.76)",
    fill: "#378bcb",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53998",
    "data-name": "Path 53998",
    d: "M62.783,342.359a37.439,37.439,0,0,0,6.559,8.573v0a65.308,65.308,0,0,1,2.876-6.793,37.412,37.412,0,0,1-5.234-9.825c-1.119,2.835-2.536,6.114-4.2,8.05Z",
    transform: "translate(-52.912 -282.315)",
    fill: "#378bcb",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53999",
    "data-name": "Path 53999",
    d: "M320.136,18.9c-1.564,3.93-4.3,9.453-6.472,13.8a3.006,3.006,0,0,1-5.376,0c-2.179-4.343-4.913-9.866-6.472-13.8C293.725-1.48,328.222-1.48,320.136,18.9Z",
    transform: "translate(-253.321 -3.613)",
    fill: "#f54756",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54000",
    "data-name": "Path 54000",
    d: "M338.885,45.188A5.19,5.19,0,1,0,333.693,40,5.19,5.19,0,0,0,338.885,45.188Z",
    transform: "translate(-281.23 -29.902)",
    fill: "#e6f1fa",
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54001",
    "data-name": "Path 54001",
    d: "M168.076,286.8c-1.559,3.93-4.293,9.458-6.467,13.8a3.006,3.006,0,0,1-5.376,0c-2.179-4.344-4.912-9.871-6.472-13.8C141.671,266.424,176.167,266.424,168.076,286.8Z",
    transform: "translate(-125.172 -229.397)",
    fill: "#f54756",
    fillRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54002",
    "data-name": "Path 54002",
    d: "M186.83,313.1a5.192,5.192,0,1,0-5.192-5.192A5.192,5.192,0,0,0,186.83,313.1Z",
    transform: "translate(-153.081 -255.688)",
    fill: "#e6f1fa",
    fillRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54003",
    "data-name": "Path 54003",
    d: "M19.563,105.6c-1.564,3.93-4.3,9.453-6.472,13.8a3.006,3.006,0,0,1-5.376,0c-2.179-4.348-4.912-9.871-6.472-13.8-8.086-20.379,26.406-20.379,18.319,0Z",
    transform: "translate(-0.005 -76.686)",
    fill: "#f54756",
    fillRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54004",
    "data-name": "Path 54004",
    d: "M38.305,131.9a5.192,5.192,0,1,0-5.192-5.192A5.192,5.192,0,0,0,38.305,131.9Z",
    transform: "translate(-27.907 -102.976)",
    fill: "#e6f1fa",
    fillRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54005",
    "data-name": "Path 54005",
    d: "M48.5,18.888c1.559,3.93,4.293,9.453,6.472,13.8a2.936,2.936,0,0,0,2.688,1.66,2.976,2.976,0,0,0,1.637-.472,3.01,3.01,0,0,1-1.05-1.188c-2.174-4.343-4.912-9.866-6.472-13.8a18.921,18.921,0,0,1-.917-2.958A10.491,10.491,0,0,1,51.6,8.6a9.968,9.968,0,0,1,7.7-4.894c-4.051-.524-8.445.912-10.633,4.311v0c-1.628,2.531-2.036,6.151-.165,10.866ZM10.985,46.321c-1.532-3.064-3.344-6.71-4.825-9.976-.624-1.367-1.183-2.665-1.647-3.825-3.706-9.343,1.537-14.4,7.522-15.177-7.073-.917-15.177,4.142-10.8,15.177,1.014,2.55,2.518,5.775,4.045,8.907h0a0,0,0,0,1,0,0c.826,1.692,1.656,3.362,2.421,4.89a2.944,2.944,0,0,0,2.688,1.66,3.015,3.015,0,0,0,1.637-.472,3.044,3.044,0,0,1-1.05-1.188ZM27.864,61.007a14.624,14.624,0,0,1-1.17-7.04c.56-4.871,4.44-7.586,8.692-8.137-6.339-.821-13.513,3.16-11.769,11.949a18.033,18.033,0,0,0,.972,3.229c1.559,3.93,4.293,9.458,6.472,13.8a2.94,2.94,0,0,0,2.688,1.66A2.976,2.976,0,0,0,35.387,76a3.007,3.007,0,0,1-1.05-1.188c-2.179-4.344-4.912-9.871-6.472-13.8Z",
    transform: "translate(0 -3.601)",
    fill: "#dd404d",
    fillRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54006",
    "data-name": "Path 54006",
    d: "M36.019,56.776a5.19,5.19,0,0,1,3.206-8.256,5.106,5.106,0,0,0-.922-.083,5.192,5.192,0,1,0,0,10.384,5.107,5.107,0,0,0,.922-.083A5.193,5.193,0,0,1,36.019,56.776ZM80.368,40a5.186,5.186,0,0,0,5.192,5.188,5.557,5.557,0,0,0,.922-.079,5.195,5.195,0,0,1,0-10.224,5.556,5.556,0,0,0-.922-.079A5.181,5.181,0,0,0,80.368,40ZM58.412,78.063a5.192,5.192,0,0,0,4.165,9.164,5.192,5.192,0,0,1,0-10.219,5.191,5.191,0,0,0-4.165,1.055Z",
    transform: "translate(-27.905 -29.899)",
    fill: "#cfd9e1",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreMoreCountries);
export default __webpack_public_path__ + "static/media/explore-more-countries.6f330a4fdc9c24e8661950ec859434c8.svg";
export { ForwardRef as ReactComponent };